/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { CheckoutSessionsRequestBuilderRequestsMetadata, type CheckoutSessionsRequestBuilder } from './checkoutSessions/index.js';
// @ts-ignore
import { PaymentMethodsRequestBuilderNavigationMetadata, PaymentMethodsRequestBuilderRequestsMetadata, type PaymentMethodsRequestBuilder } from './paymentMethods/index.js';
// @ts-ignore
import { ProductsRequestBuilderRequestsMetadata, type ProductsRequestBuilder } from './products/index.js';
// @ts-ignore
import { SubscriptionRequestBuilderNavigationMetadata, SubscriptionRequestBuilderRequestsMetadata, type SubscriptionRequestBuilder } from './subscription/index.js';
// @ts-ignore
import { type WebhookRequestBuilder, WebhookRequestBuilderRequestsMetadata } from './webhook/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /billing
 */
export interface BillingRequestBuilder extends BaseRequestBuilder<BillingRequestBuilder> {
    /**
     * The checkoutSessions property
     */
    get checkoutSessions(): CheckoutSessionsRequestBuilder;
    /**
     * The paymentMethods property
     */
    get paymentMethods(): PaymentMethodsRequestBuilder;
    /**
     * The products property
     */
    get products(): ProductsRequestBuilder;
    /**
     * The subscription property
     */
    get subscription(): SubscriptionRequestBuilder;
    /**
     * The webhook property
     */
    get webhook(): WebhookRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const BillingRequestBuilderUriTemplate = "{+baseurl}/billing";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const BillingRequestBuilderNavigationMetadata: Record<Exclude<keyof BillingRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    checkoutSessions: {
        requestsMetadata: CheckoutSessionsRequestBuilderRequestsMetadata,
    },
    paymentMethods: {
        requestsMetadata: PaymentMethodsRequestBuilderRequestsMetadata,
        navigationMetadata: PaymentMethodsRequestBuilderNavigationMetadata,
    },
    products: {
        requestsMetadata: ProductsRequestBuilderRequestsMetadata,
    },
    subscription: {
        requestsMetadata: SubscriptionRequestBuilderRequestsMetadata,
        navigationMetadata: SubscriptionRequestBuilderNavigationMetadata,
    },
    webhook: {
        requestsMetadata: WebhookRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
